/**
 * accordion-autoclose.js
 * Makes <accordion-custom> accordions behave like an exclusive group
 * (only one open at a time).
 *
 * Load this file only when your schema checkbox is true.
 */
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll("accordion-custom");

  accordions.forEach((accordion) => {
    const details = accordion.querySelector("details");
    const summary = details?.querySelector("summary");

    if (!(details instanceof HTMLDetailsElement) || !summary) return;

    summary.addEventListener("click", () => {
      // If about to open, close all other accordions first
      if (!details.open) {
        document
          .querySelectorAll("accordion-custom details[open]")
          .forEach((d) => {
            if (d !== details) {
d.open = false;
              // If pure .js, just use: d.open = false;
            }
          });
      }
    });
  });
});
